export default __webpack_public_path__ + "static/BasierCircle-Medium-4cba0883a3821a670fa4a81ae19351b0.woff";